<template>
  <div class="container">
    <Header :active="7"></Header>
    <Join></Join>
    <Office></Office>
    <div class="flex-center flex-align-center recruit">
      <a target="_blank" href="https://company.zhaopin.com/CZ540400520.htm?srccode=401901&preactionid=5b229b35-ee9a-4de2-ba5d-8197f79eaab4">
        <p>智联招聘</p>
      </a>
      <div class="shu"></div>
      <a target="_blank" href="https://www.zhipin.com/gongsir/d61e9284602c2f5f03F409y0EA~~.html?ka=company-jobs">
        <p>BOSS直聘</p>
      </a>
    </div>
    <Position></Position>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header/index'
import Join from '../components/Join/index'
import Office from '../components/Join/office'
import Position from '../components/Position/index'
import Footer from '../components/Footer/index'
export default {
  components: {
    Header,
    Join,
    Office,
    Position,
    Footer
  },
}
</script>